import { render } from "./AdminConfigurationList.vue?vue&type=template&id=74f59d85&ts=true&lang=true"
import script from "./AdminConfigurationList.vue?vue&type=script&lang=ts"
export * from "./AdminConfigurationList.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/adminold.quickup.uk/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__